'use client';

import React from 'react';
import { Question } from '../types';
import { QuizItem } from '@/store/assessment-store';
import { AnswerHandlers } from '../hooks/useAnswerHandlers';
import { renderInteractiveOptions } from './options/OptionRendererFactory';

/**
 * Single Responsibility: Render interactive question options
 * Uses factory pattern for extensibility (Open/Closed Principle)
 */
interface QuestionOptionsProps {
  question: Question;
  questionType: string;
  questionIndex: number;
  quiz: QuizItem[];
  handlers: AnswerHandlers;
  isQuiz?: boolean;
  correctAnswers?: string | string[] | boolean | null;
  quizData?: any;
  isQuestionSubmitted?: boolean;
}

export function QuestionOptions({
  question,
  questionType,
  questionIndex,
  quiz,
  handlers,
  isQuiz = false,
  correctAnswers = null,
  quizData,
  isQuestionSubmitted = false,
}: QuestionOptionsProps) {
  // Ensure quiz is always an array
  const quizArray = Array.isArray(quiz) ? quiz : [];
  const quizItem = quizArray.find((q) => q?.qindex === questionIndex);
  // For true/false questions, selected_options is a boolean, not an array
  // Default to undefined instead of [] to allow proper boolean checks
  const selectedOptions = quizItem?.selected_options !== undefined 
    ? quizItem.selected_options 
    : undefined;

  return (
    <>
      {renderInteractiveOptions({
        question,
        questionType,
        questionIndex,
        selectedOptions,
        quiz: quizArray,
        handlers,
        isQuiz,
        correctAnswers,
        quizData,
        isQuestionSubmitted,
      })}
    </>
  );
}

